/* Visivio — motion polish: anchor offset, image settle */
(function () {
  'use strict';
  if (window.__vvPolish) return;
  window.__vvPolish = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky header would otherwise cover the target of an in-page link. */
  function offsetAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#')) : '';
      if (!hash || hash === '#') return;
      /* only intercept links pointing at this page */
      var path = href.split('#')[0];
      if (path && path !== window.location.pathname && path !== '/' && path.indexOf('http') === 0) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var hd = document.querySelector('.vv-hd');
      var pad = (hd ? hd.offsetHeight : 0) + 16;
      var top = target.getBoundingClientRect().top + window.pageYOffset - pad;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', hash);
      target.setAttribute('tabindex', '-1');
      setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (err) {} }, reduce ? 0 : 420);
    });
  }

  /* Fade images in only once they have actually decoded. */
  function settleImages() {
    if (reduce) return;
    var imgs = document.querySelectorAll('.vv-proof__i img, .vv-pc__img img, .vv-pdp__media img');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.getAttribute('data-vv-fade')) return;
      img.setAttribute('data-vv-fade', '1');
      img.classList.add('vv-fadein');
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
      }
    });
    /* Never leave an image stuck invisible. */
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.vv-fadein'), function (i) { i.classList.add('is-loaded'); });
    }, 3000);
  }

  function init() { settleImages(); }
  offsetAnchors();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
